import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { CampaignList_Top_Query } from "@/components/features/marketing/campaign/top/model/repository/query/query";
import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { VoucherForCampaignUpdate_EditPage_Mutation } from "./mutation";
import { viewModelToInputConverter } from "../_shared/mutation/composition/view-model-to-input";

import type { MarketingCampaignFormModel } from "../../../type";

type Props = {
	onResetViewModel: () => void;
};

export const useCampaignEditMutation = ({ onResetViewModel }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(VoucherForCampaignUpdate_EditPage_Mutation);

	const onUpdate = useCallback(
		(
			viewModel: MarketingCampaignFormModel["ViewModel"], //
		) => {
			showLoadingScreenCallback();

			const input = viewModelToInputConverter({ viewModel });

			mutationFunc({
				variables: {
					input,
				},
				refetchQueries: [
					{
						query: CampaignList_Top_Query,
						variables: { hotelID: input.hotelID },
					},
				],
			})
				.then(({ errors }) => {
					if (!errors) {
						notifyUserEventInfo({
							variant: "default",
							title: "キャンペーンを更新しました",
						});
						onResetViewModel();
					}
				})
				.finally(() => {
					hideLoadingScreenCallback();
				});
		},
		[hideLoadingScreenCallback, mutationFunc, onResetViewModel, showLoadingScreenCallback],
	);

	return { onUpdate };
};
